import Vue from 'vue';
import _ from 'lodash';
import setter from '@/lib/setter';
import store from '@/store';
import baseApi from '@/api/baseApi';

const hdk = {
    userInfo() {
        return this.data(setter.userInfo) || {};
    },
    token() {
        return this.data(setter.tokenName) || '';
    },
    data(settings, table) {
        var table = table || setter.dataName,
            storage = localStorage;

        if (!JSON || !JSON.parse) return;

        //如果settings为null，则删除表
        if (settings === null)
            return delete storage[table];


        settings = typeof settings === 'object' ? settings : {
            key: settings
        };

        try {
            var data = JSON.parse(storage[table]);
        } catch (e) {
            var data = {};
        }

        if ('value' in settings) data[settings.key] = settings.value;
        if (settings.remove) delete data[settings.key];
        storage[table] = JSON.stringify(data);

        return settings.key ? data[settings.key] : data;
    },
    renderData(options) {
        const {
            keys,
            data,
            done
        } = options;
        if (!keys || 0 === keys.length) return;
        baseApi.getDict(keys).then(res => {
            keys.forEach((value) => {
                Vue.set(data, value, res.data[value]);
            });
            if (done && typeof done === 'function') {
                done();
            }
        }).catch(res => {
            console.error(res);
        });
    },
    dateFormat(date, fmt) {
        let ret;
        const opt = {
            'y+': date.getFullYear().toString(),
            'M+': (date.getMonth() + 1).toString(),
            'd+': date.getDate().toString(),
            'H+': date.getHours().toString(),
            'm+': date.getMinutes().toString(),
            's+': date.getSeconds().toString()
        };
        for (let k in opt) {
            ret = new RegExp('(' + k + ')').exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
            };
        };
        return fmt;
    }
}


export default hdk